import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Form, message } from 'antd';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks';
import qs from 'query-string';
import { MSG } from 'commons/constants';
import useStore from 'store';
import { useNavigate } from 'react-router-dom';

const cx = classNames.bind('./index.scss');

export interface MainProps {}

const Main = ({}: React.PropsWithChildren<MainProps>): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const [form] = Form.useForm();
  const { login, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const auth = useStore((state) => state.auth);  

  /* ======================================================
   * events
   * ====================================================== */
  const onClickLogin = () => {
    login({ email: form.getFieldValue('id'), password: form.getFieldValue('pw') });
  };

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    const error = qs.parse(location.search).error;
    if (error === 'loginDupl') message.error(MSG.ERROR_DUPLICATED_LOGIN, 1);

    (auth.login?.isCm || auth.login?.isPm || auth.login?.isOp || auth.login?.div === '101')?(
      navigate("/myroom")
    ):(
      navigate("/schedule")      
    )
  }, []);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>

    </>
  );
};

export default Main;